"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useESignInterstitial = void 0;
var useESignInterstitial_hook_1 = require("./useESignInterstitial.hook");
Object.defineProperty(exports, "useESignInterstitial", { enumerable: true, get: function () { return useESignInterstitial_hook_1.useESignInterstitial; } });
//# sourceMappingURL=index.js.map